import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box } from '@tq/ui-components';
import { EmptyDataCard } from 'components';

import { RpcOtherResponse } from '..';
import { useResponse } from '../../hooks';

export const RpcOtherResponses: React.FC = () => {
  const { t } = useTranslation('consultation_response');

  const { id } = useParams();
  const { otherAnswers } = useResponse(+(id ?? 0));

  return (
    <Box
      mt={10}
      p={{ base: 0, lg: 4 }}
      border={{ base: 'none', lg: `1px solid ${COLOURS.gray[400]}` }}
    >
      <Box p={{ base: 4, lg: 2 }} pb={{ base: 4, lg: 6 }}>
        <h3>
          <strong>{t('other_organisation_responses', 'Other organisation responses')}</strong>
        </h3>
      </Box>
      <Box px={{ base: 4, lg: 0 }}>
        {otherAnswers.map((answer) => (
          <RpcOtherResponse key={answer.id} answer={answer} />
        ))}
        {(!otherAnswers || otherAnswers.length === 0) && (
          <Box px={{ base: 0, lg: 2 }}>
            <EmptyDataCard message={t('no_responses_message', 'No responses available')} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
